import { render, staticRenderFns } from "./IntegrationView.vue?vue&type=template&id=976dad84&scoped=true"
import script from "./IntegrationView.vue?vue&type=script&lang=js"
export * from "./IntegrationView.vue?vue&type=script&lang=js"
import style0 from "./IntegrationView.vue?vue&type=style&index=0&id=976dad84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "976dad84",
  null
  
)

export default component.exports